import { usePostApiData } from "../../../../shared/datalayer";
import MyExpApi from "../../enum/MyExpApi";
import ApiAnalyticsLogRequest from "../../../../shared/types/ApiAnalyticsLogRequest";

export function useLogAnalyticsEvent() {
  return usePostApiData<void, ApiAnalyticsLogRequest>(MyExpApi.ANALYTICS_EVENT_LOG, {
    clientOptions: { displayErrorMessage: false },
    hideLoader: true
  });
}
